module.exports = __webpack_public_path__ + "static/media/vp_price.e69815e1.svg";